// TODO this will only work with one homepage carousel elm onscreen. But I don't think it's likely there will be more than one, sicne it's not even a block.
// TODO when the (visually) top element transitions in, afterwards the other elms will trans out unseen. Not 100% sure but this could be a waste of GPU cycles. They should just disappear.

(function () {
    'use strict';

    const slideChangeRate = 4000;

    const carousel = document.querySelector('.js-homepagecarousel');
    const carouselImages = carousel ? carousel.querySelectorAll('img') : false;

    const classShow = 'headerMainHome__layout__carousel__img--show';
    const classShow_first = 'headerMainHome__layout__carousel__img--first';

    function shiftCarouselImages() {
        const topElement = carousel.firstElementChild;                          // "top" in terms of DOM order not visibility
        carousel.removeChild(topElement);
        carousel.appendChild(topElement);
    }


    function checkImageLoaded(image) {
        if (image.complete) {
            return true;
        } else {
            image.addEventListener('load', function () {
                shiftCarouselImages(carousel);
                showImageAndAddListener();
            }, { once: true });
        }
    }


    function hideAllButOne(dontHideThisOne) {
        // remove all "show" classes aside from the one in front
        carouselImages.forEach(function (image) {
            if (image !== dontHideThisOne) {
                image.classList.remove(classShow);
            }
        });
    }


    function showImageAndAddListener() {
        setTimeout(function () {
            carousel.lastElementChild.classList.add(classShow);
            carousel.lastElementChild.addEventListener('transitionend', handleTransitionEnd);
        }, 16);
    }


    function handleTransitionEnd(e) {
        if (e.propertyName !== 'opacity' || e.target.classList.contains(classShow_first)) {
            e.target.classList.remove(classShow_first);
            e.target.removeEventListener('transitionend', handleTransitionEnd);
            // remove all "show" classes aside from the one in front
            hideAllButOne(carousel.lastElementChild);

            // shift back one to front
            shiftCarouselImages(carousel);

            // if the one now in front is ready
            if (checkImageLoaded(carousel.lastElementChild)) {
                setTimeout(showImageAndAddListener, slideChangeRate);
            }
        }
    }


    /**
     * Main
     */

    if (carousel && carousel.children.length > 1) {
        if (checkImageLoaded(carousel.firstElementChild)) {
            shiftCarouselImages(carousel);
            setTimeout(function () {
                showImageAndAddListener();
            }, 16);
        }
    }

})();